import * as EncounterHistory from '../../Encounter/EncountersHistory/actions.js'
import * as EnrollmentActions2 from '../../shared/Enrollment/enrollmentActions2.js'
import { compartmentReceive, getSpecData } from '../patientActions.js'
import { getESASBanner } from '../Standard/Symptoms/ESAS/actions.js'

// action types
export const PATIENT_BANNER = 'PATIENT_BANNER'
export const PATIENT_BANNER_SUCCESS = 'PATIENT_BANNER_SUCCESS'
export const PATIENT_BANNER_RESET = 'PATIENT_BANNER_RESET'

export function request () {
  return {
    type: PATIENT_BANNER
  }
}

function success (data) {
  return {
    type: PATIENT_BANNER_SUCCESS,
    data
  }
}

export function reset () {
  return dispatch => {
    dispatch({
      type: PATIENT_BANNER_RESET
    })
  }
}

export function getPatientBanner (clientName, patientId) {
  return (dispatch, getState) => {
    let state = getState()

    clientName = clientName ?? state.globalVars?.params?.clientName
    patientId = patientId ?? state.globalVars?.params?.id
    dispatch(request())
    dispatch(getSpecData(patientId, clientName))
    dispatch(compartmentReceive(patientId, clientName))
    dispatch(getESASBanner(patientId, clientName))
    dispatch(EncounterHistory.init(patientId, clientName))
    dispatch(EnrollmentActions2.searchEnrollment(`Patient/${patientId}`, patientId))
  }
}

export function updatePatient (patient) {
  return success(patient)
}
